<template>
  <IonPage>
  <master-layout pageTitle="لیست درآمدها">
    <IonCardContent>
    <DataTable auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
    </IonCardContent>
  </master-layout>
  </IonPage>
</template>

<script>
import {IonPage,IonCardContent} from "@ionic/vue";
import DataTable from "@/components/DataTable";
export default {
  name: "list",
  components: {IonCardContent,DataTable,IonPage},
  data ()
  {
    return {
      route: null,
      headers: [
          'تاریخ',
          'شماره سند',
          'مبلغ فروش',
          'مبلغ پورسانت',
          'امکانات',
      ],
    }
  },
  async created()
  {
    this.route = 'commission/listAjax';
  }
}
</script>

<style scoped>

</style>